import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { Tabs } from 'antd';
import mobileColumns from '../../../../columns/dashboardAccountMobile';
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton';

const MobileAccountTabs = ({ data, loading }) => {
    const [activeTab, setActiveTab] = useState(1);
    const [filteredData, setFilteredData] = useState([]);

    const items = [
        { key: 1, label: 'Live Account' },
        { key: 2, label: 'Demo Account' },
    ];

    useEffect(() => {
        let accounts = [];

        if (activeTab === 1) {
            accounts = data?.filter((account) => account?.isLive);
        } else if (activeTab === 2) {
            accounts = data?.filter((account) => account?.isDemo);
        }

        setFilteredData(accounts?.map((item) => {
            return {
                ...item,
                balance: `$ ${item?.balance}`,
                createdAt: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
            }
        }));
    }, [activeTab, data]);

    return (
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100">
            <div className="border-b px-3 border-gray-200">
                <Tabs
                    defaultActiveKey="1"
                    items={items}
                    onChange={(tab) => setActiveTab(tab)}
                    className="w-full custom-tabs custom-tabs-mobile"
                    centered={true}
                />
            </div>

            <div className="pt-4">
                <div className="overflow-hidden">
                    <TableWithSkeleton
                        columns={mobileColumns}
                        loading={!data?.length}
                        data={filteredData}
                        pagination={false}
                        size="small"
                        className="mobile-account-table"
                    />
                </div>
            </div>
        </div>
    );
}

export default MobileAccountTabs